import { notifyError } from 'helpers/errorNotifier';

export const safeAtob = (value, options = {}) => {
	const { reportError = true } = options;

	if (!value || typeof value !== 'string') return value;
	try {
		return window.atob(value);
	} catch {
		if (reportError) {
			notifyError(`'Failed to execute 'atob' on 'Window', for text '${value}'`);
		}

		return value;
	}
};
